import { useContext, useState } from "react";
import './styles/Home.css';
import { IoAdd } from "react-icons/io5";
import { Note } from "../classes/Note";
import { v4 as uuidv4 } from 'uuid';
import NoteComponent from "../components/NoteComponent";
import { Client } from "@microsoft/microsoft-graph-client";
import { useGraphWithCredential } from "@microsoft/teamsfx-react";
import { TeamsUser } from "../classes/TeamsUser";
import { NotesService } from "../services/notes.service";
import { GRAPH_RIGHTS_SOCPE } from "../Constant";
import { t } from "i18next";
import packageJson from '../../package.json';
import { TeamsFxContext } from "../components/Context";


export const Home = () => {

    const [notes, setNotes] = useState<Note[]>([]);
    const [user, setUser] = useState<TeamsUser>();
    const [error, setError] = useState<string>("");

    const { teamsUserCredential } = useContext(TeamsFxContext);

    /**
     * Va chercher les notes de l'utilisateur et en ajoute une si elle n'existe pas 
     * @param userId 
     */
    const updateNotes = async (userId: string) => {
        const newNotes = (await NotesService.getNotes(userId)).sort((a, b) => a.order - b.order);
        if (newNotes.length === 0) {
            addNote(userId);
        }
        else {
            setNotes(newNotes);
        }
    }

    useGraphWithCredential(
        async (graph: Client, teamsUserCredential, scope) => {
            setError("");

            const profile: TeamsUser = await graph.api("/me").get().catch((err) => {
                console.error("Error TS in /me " + err)
                setError(error + t("err_get_me") + err);  
            });
            const users = await graph.api("/users").get().catch((err) => { 
                console.error("Error TS in /users " + err)
                setError("\n"+error + t("err_get_users") + err);
            });
            setUser(profile);

            updateNotes(profile.id);
            NotesService.userProfile = profile;
            NotesService.connectedUsers = users.value.filter((u: TeamsUser) => u.id !== profile.id);

            console.log("profile", profile);
            console.log("users", NotesService.connectedUsers);

            return { profile, users };
        },
        { scope: GRAPH_RIGHTS_SOCPE, credential: teamsUserCredential }
    );

    const addNote = async (userId: string = "") => {
        if (notes.length<25){
            const id = uuidv4();
            const newNote = await NotesService.addNote(new Note({
                id,
                createUserId: user?.id ?? userId,
                name: t("new_title"),
                content: t("new_content"),
                order: notes.length,
            }));
            setNotes([...notes, newNote].sort((a, b) => a.order - b.order));
        }
        else {
            alert(t("limit_note"));
        } 
    }

    const editNoteNameEnd = async (newName: string, noteId: string) => {
        console.log("editNoteNameEnd");
        const index = notes.findIndex(n => n.id === noteId);
        if (index !== -1) {
            const newNotes = notes.map(n => new Note(n));
            let note = newNotes[index];
            note.name = newName;
            note = await NotesService.editNote(note);
            newNotes[index] = note;

            setNotes(newNotes);
        }
    }

    const editNoteContentEnd = async (newContent: string, noteId: string) => {
        console.log("editNoteContentEnd");
        const index = notes.findIndex(n => n.id === noteId);
        if (index !== -1) {
            const newNotes = notes.map(n => new Note(n));
            let note = newNotes[index];
            note.content = newContent;
            note = await NotesService.editNote(note);
            newNotes[index] = note;

            setNotes(newNotes);
        }
    }

    const deleteNote = (noteId: string) => {
        NotesService.deleteNote(noteId);
        setNotes(notes.filter(n => n.id !== noteId).sort((a, b) => a.order - b.order));
    }



    return (   
        <div className="page-container">
            <span className="version">{packageJson.version}</span>
            <div className="page-header">
            <h2 className="header-title">{user?.displayName}</h2>
                <button className="button" onClick={() => addNote()}>
                    <IoAdd className="add-icon" />
                </button>
            </div>
                <div className="notes-container">
                    {
                        error.length !== 0 && <span className={"msg_err" + (error.length === 0 ? "hidden" : "")} >{error}</span>
                    }
                    
                    {
                        notes.map(note =>
                            <NoteComponent
                                key={note.id}
                                note={note}
                                onEditNameEnd={(newName) => editNoteNameEnd(newName, note.id)}
                                onEditContentEnd={(newContent) => editNoteContentEnd(newContent, note.id)}
                                onDeleteNote={() => deleteNote(note.id)} />
                        )
                    } 
                </div>
                
            
            
        </div>
    )
}

export default Home;